// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { SEARCH_TAGS_ORDER_BY_KEY } from "../../../app/localStorageKeys"

export type StorageReader = () => Observable<number>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(SEARCH_TAGS_ORDER_BY_KEY)
    if (data !== null) {
      // convert to number for matching index from SearchTagsRequest.OrderBy enum
      return of(Number(data))
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadOrderBy = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.loadOrderByFromStorage.match),
      mergeMap(_ => load().pipe(
        map(Slice.setSearchOrderBy),
        catchError(_ => of(Actions.loadOrderByFromStorageFailed())),
      )),
    )

export default loadOrderBy(load)

